import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";

import WGRTable from "./lslTable";
import WGRTotals from "./lslTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
    return rows.reduce(
      (sum, row) => ({
        highlyskilledtime:
          sum.highlyskilledtime +
          Number(row.HIGHLYSKILLEDTIME || 0),

        highlyskilledcost:
          sum.highlyskilledcost +
          Number(row.HIGHLYSKILLEDCOST || 0),

        skilledtime:
          sum.skilledtime +
          Number(row.SKILLEDTIME || 0),

        skilledcost:
          sum.skilledcost +
          Number(row.SKILLEDCOST || 0),

        semiskilledtime:
          sum.semiskilledtime +
          Number(row.SEMISKILLEDTIME || 0),

        semiskilledcost:
          sum.semiskilledcost +
          Number(row.SEMISKILLEDCOST || 0),

        unskilledtime:
          sum.unskilledtime +
          Number(row.UNSKILLEDTIME || 0),

        unskilledcost:
          sum.unskilledcost +
          Number(row.UNSKILLEDCOST || 0),

        oncostlabour:
          sum.oncostlabour +
          Number(row.ONCOSTLABOUR || 0),

         oncoststore:
          sum.oncoststore +
          Number(row.ONCOSTSTORE || 0),
      }),
      {
        highlyskilledtime: 0,
        highlyskilledcost: 0,
        skilledtime: 0,
        skilledcost: 0,
        semiskilledtime: 0,
        semiskilledcost: 0,
        unskilledtime: 0,
        unskilledcost: 0,
        oncostlabour: 0,
        oncoststore:0,
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Shop Number : {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

      <WGRTable rows={rows} />

      {/* Shop Total */}

      <WGRTotals
        shop={shop}
        totals={totals}
      />
    </Paper>
  );
}

